import { render } from "./BpmOgpoParticipantsStep.vue?vue&type=template&id=213d8090"
import script from "./BpmOgpoParticipantsStep.vue?vue&type=script&lang=js"
export * from "./BpmOgpoParticipantsStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__